module.exports = __webpack_public_path__ + "static/media/moveInspector.7dd34aa2.mp4";